module.exports = __webpack_public_path__ + "static/media/profile.2576d0d6.gif";